import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';

import { catchErrorLogRet } from '../common/rest.operators';
import {
    TakeUntilDestroy,
    takeUntilDestroy,
} from '../common/take-until-destroy.decorator';

import { Language } from './i18n.model';
import { I18nService } from './i18n.service';

@Component({
    selector: 'cmps-i18n-switcher',
    templateUrl: './switcher.i18n.component.html',
})
@TakeUntilDestroy()
export class SwitcherI18nComponent {
    /** @private */
    _pending: boolean;

    private _switchSub: Subscription;

    /** @private */
    get _currentLocale(): string {
        return this._i18nService.currentLocale;
    }

    /** @private */
    get _languages(): Language[] {
        return this._i18nService.languages;
    }

    constructor(
        private readonly _translateService: TranslateService,
        private readonly _i18nService: I18nService,
    ) {}

    /** @private */
    _onLanguageSelect(language: Language): void {
        this._switchSub?.unsubscribe();
        this._i18nService.locale = language.initial;
        this._pending = true;
        this._switchSub = this._translateService
            .use(language.id.toString())
            .pipe(
                catchErrorLogRet(null),
                tap(() => {
                    this._pending = false;
                }),
                takeUntilDestroy(this),
            )
            .subscribe();
    }
}
